import React, { Component } from "react";
import "./QuizScreen.scss";
import Welcome from "../Welcome/Welcome";
import { usingQuizzesAPI } from "../Services/fetchService";
import { DomRadioField } from "../Services/formDOM";
import { returnValue } from "../Services/formHandlers";
import EndScreen from "../EndScreen/EndScreen";
import Loading from "../Services/Loading/Loading";
import { mobile } from "../Services/Agent";
import { GA_Push } from "../Services/GoogleAnalytics";

export default class QuizScreen extends Component {
    constructor() {
        super();
        this.state = {
            time: 1,
            current: 0,
            Proxy: -1,
            isBusy: false,
            isLoading: false
        }
    }
    componentDidMount() {
        this.setState({
            time: new Date().getTime()
        })
        // this.props.setScreen(<EndScreen className="thankyou" />)
    }
    getQuestions = () => {
        return this.props.QuizQuestions.map((item, index) =>
            <QuizzQuestion key={index} index={index}
                limit={this.props.QuizQuestionslength}
                handleInputChange={this.handleInputChange}
                current={this.state.current}
                onClick={{
                    navigate: this.navigate,
                    saveAndValidate: this.saveAndValidate
                }}
                state={this.state}
                {...item}
            />
        )
    }
    handleInputChange = event => {
        this.setState({
            [event.target.name]: {
                ...this.state[event.target.name],
                error: "",
                label: event.target.dataset.label ? event.target.dataset.label : "",
                question: event.target.dataset.question ? event.target.dataset.question : "",
                value: (event.target.dataset && event.target.dataset.bool === "true" ? (this.state[event.target.name].value ? 0 : 1) : event.target.value)
            },
            Proxy: (this.state.current != this.state.Proxy ? Math.round(this.state.Proxy + 1) : this.state.Proxy)
        });
    }
    navigate = _num => {
        if (!this.state[`question${_num - 1}`]) {
            alert("יש לענות על אחת מהתשובות");
            return;
        }

        var num = (_num > this.props.QuizQuestionslength - 1 ? this.props.QuizQuestionslength - 1 : _num);
        num = (_num < 0 ? 0 : _num);
        this.setState({
            current: num
        })
    }
    saveAndValidate = () => {
        if (this.state.isBusy) return;
        this.setState({
            isBusy: true
        });

        const state = this.state,
            Parent = this.props.formScreenState,
            Answers = [], _Answers = [];

        let counter = 0;

        for (var i = 0; i < this.props.QuizQuestionslength; i++) {
            if (state[`question${i}`]) {
                _Answers.push({ Answer: state[`question${i}`].label, Question: state[`question${i}`].question })
                Answers.push(parseInt(state[`question${i}`].value))
                counter++
            }
        }

        if (counter < this.props.QuizQuestionslength) {
            alert("לא ניתן לשלוח את החידון מבלי לענות על כל השאלות");
            return;
        }

        this.setState({
            isLoading: true
        }, () => {
            usingQuizzesAPI.saveResults({
                FullName: returnValue(Parent.FullName),
                Age: returnValue(Parent.Age),
                Gender: returnValue(Parent.Gender),
                Email: returnValue(Parent.Email),
                PhoneNumber: returnValue(Parent.PhoneNumber),
                Answers: Answers,
                TimeTaken: Math.round((new Date().getTime() - this.state.time))
            }, (data) => {
                // _Answers.map(item => {
                //     GA_Push(item.Question, item.Answer);
                // })
                GA_Push("quiz sent");
                this.setState({
                    isLoading: false,
                    isBusy: false
                }, () => this.props.setScreen(<EndScreen className="thankyou" />));
            })
        })
    }
    render() {
        return (
            <section className="section section-quiz">
                <div className="q-padding">
                    <div className="q-container">
                        <Welcome />
                        <Loading showLoading={this.state.isLoading} />
                        <div className="bar">
                            {(() => this.props.QuizQuestions.map((item, index) =>
                                <div key={index} className={`baritem ${this.state.current == index ? "current" : ""} ${index <= this.state.current ? " active" : ""}`}>
                                    שאלה {index + 1}
                                </div>)
                            )()}
                        </div>
                        <div className="wrapper">
                            <div className="questions-block" style={{
                                transform: `translate3d(${this.state.current * (mobile() ? window.document.body.clientWidth : 1000)}px,0,0)`,
                                width: `${this.props.QuizQuestionslength * (mobile() ? window.document.body.clientWidth : 1000)}px`
                            }}>
                                {this.getQuestions()}
                            </div>
                        </div>
                        <div className="bottom-image">
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

const QuizzQuestion = props => {
    return (
        <div>
            <div className={`quiz ${props.current == props.index ? " active" : ""}`}>
                <div className="quiz-container">
                    <div className="headline">
                        <div className="num">
                            {`${Math.round(props.index + 1)}.`}
                        </div>
                        <div className="head">
                            <h4>
                                {props.Question}
                            </h4>
                        </div>
                    </div>
                    <div className="questions">
                        {
                            props.Answers.map((item, index) =>
                                <DomRadioField key={index} index={index}
                                    value={item.ID}
                                    question={props.Question}
                                    label={item.Answer}
                                    type="radio"
                                    name={`question${props.index}`}
                                    id={`question${props.index}_${index} `}
                                    onChange={props.handleInputChange} />
                            )
                        }
                    </div>
                    <div className="button" onClick={() => {
                        GA_Push(props.Question, props.state[`question${props.index}`].label)
                        if (props.index + 1 == props.limit) {
                            props.onClick.saveAndValidate();
                        } else {
                            props.onClick.navigate(props.index + 1);
                        }
                    }}>
                        {props.index + 1 == props.limit ? "שלח" : "הבא"}
                    </div>
                </div>





            </div>
            {props.index + 1 == props.limit ?
                
                <div className="button-send" onClick={() => {
                    GA_Push(props.Question, props.state[`question${props.index}`].label)
                    if (props.index + 1 == props.limit) {
                        props.onClick.saveAndValidate();
                    } else {
                        props.onClick.navigate(props.index + 1);
                    }
                }}>
                    {props.index + 1 == props.limit ? "שלח" : ""}
                </div>
                : ""}
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/Components/QuizScreen/QuizScreen.jsx